import Resource from '@/services/resources/common';

// question type
export default class ReportInstanceTypeResource extends Resource {
  constructor(entrypoint = '/report_instance_types', alias = 'ReportInstanceType') {
    super(entrypoint, alias);
  }
}
